import React, { ReactElement, useState } from "react";

import { Tab, Tabs } from "react-bootstrap";

import styles from "./TabBar.module.scss";

export type Tab = {
  ButtonLabel: string;
  TabContent: ReactElement;
};

const TabBar = ({ tabs, defaultActiveKey }: { tabs: Tab[]; defaultActiveKey?: string }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveKey || tabs[0].ButtonLabel);
  return (
    <Tabs defaultActiveKey={defaultActiveKey || tabs[0].ButtonLabel} className={styles["tabbar-wrapper"]}>
      {tabs.map((tab) => (
        <Tab
          eventKey={tab.ButtonLabel}
          title={
            <div
              onClick={() => setActiveTab(tab.ButtonLabel)}
              className={activeTab === tab.ButtonLabel ? styles["active-tab"] : styles["tab"]}
            >
              {tab.ButtonLabel}
            </div>
          }
          key={tab.ButtonLabel}
        >
          <div className="pt-4 mt-2">{tab.TabContent}</div>
        </Tab>
      ))}
    </Tabs>
  );
};

export default TabBar;
